import { useLayoutEffect } from "react";
import { ladeschirmHalten } from "../lib/ladeschirm";
import { Loading } from "./States";

/**
 * Hält den Ladeschirm des Portals (index.html, lib/ladeschirm.ts), solange die Komponente steht: als Fallback für
 * nachgeladene Seiten (Suspense) und beim Start, bis Anmeldung und Konto geladen sind. Zeichnet selbst nichts; der
 * Ladeschirm liegt außerhalb von React und bleibt so beim Wechsel vom statischen HTML zur App ohne Sprung stehen.
 */
export function Ladeschirm(): null {
  useLayoutEffect(() => ladeschirmHalten(), []);
  return null;
}

/** Die ganze Seite lädt noch (Start, Anmeldung, Konto, Sprungziel aus Mails): Ladeschirm halten, darunter der übliche Hinweis. */
export function StartLaden() {
  return (
    <>
      <Ladeschirm />
      <Loading />
    </>
  );
}
